/* eslint-disable import/prefer-default-export */
import { get, post, put, remove, download } from '@src/services/NetworkUtils'

export const WorkforceService = {
  getWorkforce: async (params) => await get('/v1/workforce', params),
  // When `params.enquiryId` is set, the path becomes /v1/workforce/:id/:enquiry_id —
  // the Report + Risk Signals tabs swap to that enquiry's snapshot. Without
  // `enquiryId`, the call falls back to the latest enquiry (existing behaviour).
  // `enquiryId` is stripped from the query string before forwarding.
  getWorkforceDetail: async (id, params = {}) => {
    const { enquiryId, ...query } = params || {}
    const path = enquiryId ? `/v1/workforce/${id}/${enquiryId}` : `/v1/workforce/${id}`
    return await get(path, query)
  },
  createWorkforce: async (data) => await post('/v1/workforce', data),
  updateWorkforce: async (id, data) => await put(`/v1/workforce/${id}`, data),
  deleteWorkforce: async (ids) => await remove('/v1/workforce', { ids }),
  exportWorkforce: (params) => download('/v1/workforce/export', params),
  downloadImportTemplate: () => download('/v1/workforce/import-template'),
  importWorkforce: async (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return await post('/v1/workforce/import', formData, 'form-data')
  },
  // Option lookups for form dropdowns. Entity dropdown is scoped to the
  // logged-in user's assigned companies (user_companies), matching ReportEnquiry.
  getCompanyOptions: async (params) => await get('/v1/option/my-company-list', params),
  getLevelOptions: async (params) => await get('/v1/settings/employment-level/levels', params),
  getPositionOptions: async (params) => await get('/v1/settings/employment-level/positions', params),
}
